import { Dashboard } from "./components/Dashboard";
import { Home } from "./components/Home";
import { Patients } from "./components/Patients";
import { PatientWorkspace } from "./components/PatientWorkspace";
import { VisitWorkspace } from "./components/VisitWorkspace";
import { Diets } from "./components/Diets";
import { Agenda } from "./components/Agenda";
import { SistemaTs } from "./components/SistemaTs";
import { Invoices } from "./components/Invoices";
import { Administration } from "./components/Administration";
import { SibillaCopilot } from "./components/SibillaCopilot";

const AppRoutes = [
  {
    index: true,
    element: <Dashboard />
  },
  {
    path: "/copilot",
    element: <SibillaCopilot />
  },
  {
    path: "/patients",
    element: <Patients />
  },
  {
    path: "/patients/:id",
    element: <PatientWorkspace />
  },
  {
    path: "/patients/:id/visits/new",
    element: <VisitWorkspace />
  },
  {
    path: "/patients/:id/visits/:visitId",
    element: <VisitWorkspace />
  },
  {
    path: "/diets",
    element: <Diets />
  },
  {
    path: "/agenda",
    element: <Agenda />
  },
  {
    path: "/bia",
    element: <Home />
  },
  {
    path: "/visits/new",
    element: <Home />
  },
  {
    path: "/sistema-ts",
    element: <SistemaTs />
  },
  {
    path: "/invoices",
    element: <Invoices />
  },
  {
    path: "/administration",
    element: <Administration />
  }
];

export default AppRoutes;
